import { INTAKE_FORM_INCOMPLETE, STARTED_INTAKE_FORM } from '@/util/constants';

export function clientNeedsFullIntakeForm(client: Client | null): boolean {
  if (!client) return false;
  if (client.formReferenceStatus === 'completed') return false;
  if (client.metadata?.assumptionsSet === true) return false;
  if (client.formReferenceId) return true;

  const hasIncompleteTag = client.clientTags?.some(
    tag => tag === INTAKE_FORM_INCOMPLETE || tag === STARTED_INTAKE_FORM,
  );

  const isQuickPlanClient = client.metadata?.createdVia === 'short-intake-form';

  return hasIncompleteTag || isQuickPlanClient;
}

export function toNoonUTC(date: Date): Date {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0));
}
